import React from 'react';
import Image from '../Image/Image';
import Headline from '../Headline/Headline';
import { Wrapper } from './Text.styles';

const Text = ({ content }) => {
  const { headline, text } = content;

  return (
    <>
      {content.addImage === '1' && content.floating === 'above' && (
        <Image content={content} />
      )}

      {headline && <Headline unit={headline.unit} value={headline.value} />}

      <Wrapper dangerouslySetInnerHTML={{ __html: text }} />

      {content.addImage === '1' && content.floating === 'below' && (
        <Image content={content} />
      )}
    </>
  );
};

export default Text;
